'use strict';
'use client';
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.MaxWidthStyled = exports.MaxWidth = void 0;
const Breakpoints_Styled_1 = require('./Breakpoints.Styled');
const react_1 = require('@emotion/react');
const react_2 = __importDefault(require('react'));
const styled_1 = __importDefault(require('@emotion/styled'));
const config_1 = __importDefault(require('./utils/config'));
const Align = ({
  options,
  align = options === null || options === void 0
    ? void 0
    : options.positioning.align,
  flex = options === null || options === void 0 ? void 0 : options.flex.on,
  grid = options === null || options === void 0 ? void 0 : options.grid.on,
}) =>
  (grid || flex) &&
  (0, react_1.css)`
    align-items: ${align};
  `;
const Dir = ({
  options,
  dir = options === null || options === void 0 ? void 0 : options.flex.dir,
  flex = options === null || options === void 0 ? void 0 : options.flex.on,
}) =>
  flex &&
  (0, react_1.css)`
    flex-direction: ${dir === 'col' ? 'column' : 'row'};
  `;
const ColGap = ({
  options,
  colGap = options === null || options === void 0
    ? void 0
    : options.spacing.colGap,
  flex = options === null || options === void 0 ? void 0 : options.flex.on,
  grid = options === null || options === void 0 ? void 0 : options.grid.on,
}) =>
  (grid || flex) &&
  (0, react_1.css)`
    column-gap: ${colGap}rem;
  `;
const Grid = ({
  options,
  grid = options === null || options === void 0 ? void 0 : options.grid.on,
  cols = options === null || options === void 0 ? void 0 : options.grid.cols,
  colsXs = 1,
  colsSm = Math.max(Math.round(cols || 1 / 2), 1),
  colsMd = Math.max(Math.round(cols || 1 / 2), 1),
  colsLg = cols || 1,
  colsXl = cols || 1,
}) =>
  grid &&
  (0, Breakpoints_Styled_1.mq)({
    display: 'grid',
    gridTemplateColumns: [
      `repeat(${colsXs}, minmax(0, 1fr))`,
      `repeat(${colsSm}, minmax(0, 1fr))`,
      `repeat(${colsMd}, minmax(0, 1fr))`,
      `repeat(${colsLg}, minmax(0, 1fr))`,
      `repeat(${colsXl}, minmax(0, 1fr))`,
    ],
  });
const Flex = ({
  options,
  flex = options === null || options === void 0 ? void 0 : options.flex.on,
}) =>
  flex &&
  (0, react_1.css)`
    display: flex;
    flex-wrap: wrap;
  `;
const Justify = ({
  options,
  flex = options === null || options === void 0 ? void 0 : options.flex.on,
  grid = options === null || options === void 0 ? void 0 : options.grid.on,
  justify = options === null || options === void 0
    ? void 0
    : options.positioning.justify,
}) =>
  (grid || flex) &&
  (0, react_1.css)`
    justify-content: ${justify};
  `;
const Padding = ({ options, padding }) =>
  padding &&
  (0, react_1.css)`
    padding-right: ${
      padding === true
        ? options === null || options === void 0
          ? void 0
          : options.spacing.padding
        : padding
    }rem;
    padding-left: ${
      padding === true
        ? options === null || options === void 0
          ? void 0
          : options.spacing.padding
        : padding
    }rem;
  `;
const RowGap = ({
  options,
  flex = options === null || options === void 0 ? void 0 : options.flex.on,
  grid = options === null || options === void 0 ? void 0 : options.grid.on,
  rowGap = options === null || options === void 0
    ? void 0
    : options.spacing.rowGap,
}) =>
  (grid || flex) &&
  (0, react_1.css)`
    row-gap: ${rowGap}rem;
  `;
const Top = ({
  options,
  top = options === null || options === void 0
    ? void 0
    : options.positioning.top,
}) => (0, react_1.css)`
    margin-top: ${top}rem;
  `;
const Bottom = ({
  options,
  bottom = options === null || options === void 0
    ? void 0
    : options.positioning.bottom,
}) => (0, react_1.css)`
    margin-bottom: ${bottom}rem;
  `;
const Size = ({
  options,
  padding,
  size = options === null || options === void 0
    ? void 0
    : options.sizing.default,
  sizes = options === null || options === void 0
    ? void 0
    : options.sizing.sizes,
}) =>
  size &&
  sizes &&
  (0, react_1.css)`
    width: 100%;
    max-width: ${
      size === 'none'
        ? 'none'
        : `${
            sizes[size] +
            (padding === true
              ? ((options === null || options === void 0
                  ? void 0
                  : options.spacing.padding) || 0) * 2
              : (padding || 0) * 20)
          }px`
    };
    margin-left: auto;
    margin-right: auto;
  `;
exports.MaxWidth = styled_1.default.div(
  Align,
  ColGap,
  Dir,
  Flex,
  Grid,
  Justify,
  Padding,
  RowGap,
  Size,
  Bottom,
  Top
);
function MaxWidthStyled(props) {
  var _a, _b, _c, _d, _e;
  const theme = (0, react_1.useTheme)();
  const options = {
    flex: Object.assign(
      Object.assign({}, config_1.default.flex),
      (_a = theme.H31Layout) === null || _a === void 0 ? void 0 : _a.flex
    ),
    grid: Object.assign(
      Object.assign({}, config_1.default.grid),
      (_b = theme.H31Layout) === null || _b === void 0 ? void 0 : _b.grid
    ),
    positioning: Object.assign(
      Object.assign({}, config_1.default.positioning),
      (_c = theme.H31Layout) === null || _c === void 0 ? void 0 : _c.positioning
    ),
    sizing: Object.assign(
      Object.assign({}, config_1.default.sizing),
      (_d = theme.H31Layout) === null || _d === void 0 ? void 0 : _d.sizing
    ),
    spacing: Object.assign(
      Object.assign({}, config_1.default.spacing),
      (_e = theme.H31Layout) === null || _e === void 0 ? void 0 : _e.spacing
    ),
  };
  return react_2.default.createElement(
    exports.MaxWidth,
    Object.assign({}, props, { options: options })
  );
}
exports.MaxWidthStyled = MaxWidthStyled;
//# sourceMappingURL=Layout.Styled.js.map
